import i18n from '../vue-i18n/i18n'

export default {
  setLang (state, lang) {
    state.lang = lang
    i18n.locale = lang
  },
  setJHSS (state, jhss) {
    state.JHSS = jhss
  },
  // setCityVal (state, city) {
  //   state.cityVal = city
  // },
  setCustomerParam (state, param) {
    state.JHSS_customer_param = param
  },
  setAddresseeParam (state, param) {
    state.JHSS_addressee_param = param
  },
  setOrderManageParam (state, param) {
    state.JHSS_orderManage_param = param
  },
  setOrderCheckParam (state, param) {
    state.JHSS_orderCheck_param = param
  },
  setSignManageParam (state, param) {
    state.JHSS_signManage_param = param
  },
  setDeliveryManageParam (state, param) {
    state.JHSS_deliveryManage_param = param
  },
  setDeliveryDetailParam (state, param) {
    state.JHSS_deliveryDetail_param = param
  },
  setTempeoraryManageParam (state, param) {
    state.JHSS_tempeoraryManage_param = param
  },
  setContainerInfoParam (state, param) {
    state.JHSS_containerInfo_param = param
  },
  setDiaoDuInfoParam (state, param) {
    state.JHSS_diaoduInfo_param = param
  },
  setContainerQueryParam (state, param) {
    state.JHSS_containerQuery_param = param
  },
  setOrderHistoryParam(state, param) {
    state.JHSS_orderHistory_param = param
  },
  setformalManageParam(state, param) {
    state.JHSS_formalManage_param = param
  },
  setReservedCargoManage_param(state, param) {
    state.JHSS_reservedCargoManage_param = param
  }
}
